/**
 * Ship the headless SDK and bundled UI together. DO's deploy-on-push can build
 * new source before its live env is reconciled with do/*.yaml. next.config.ts
 * inlines this public version so a stale Core 2 env pin cannot select the old
 * SDK for the patched Core 3 UI.
 */
export const CLERK_WEB_JS_VERSION = "6.42.1";
